import { I18n } from '@aws-amplify/core';

import { RISK_LEVEL_LABEL_KEYS } from '@/components/views/Report/KimLhc/Report/Steps/Result/Constants';
import { useGetSummaryMessages } from '@/components/views/Report/KimLhc/Report/Steps/Result/hooks/useGetSummaryMessages';
import type { RiskLevel } from '@/types';

export type RiskSummary = ReturnType<typeof useGetSummaryMessages>;

export function formatScore(score: number, risk: RiskLevel): string {
	const result = `${score}: ${I18n.get(RISK_LEVEL_LABEL_KEYS[risk])}`;

	return result;
}
